import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withModifiers as _withModifiers, withKeys as _withKeys, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "alert-input-consecutive" }
const _hoisted_2 = { class: "label" }
const _hoisted_3 = ["value"]
const _hoisted_4 = ["value"]
const _hoisted_5 = {
  key: 0,
  class: "default-value"
}

import { i18n } from '@/i18n';
import { computed } from 'vue';


export default /*@__PURE__*/_defineComponent({
  __name: 'AlertInputConsecutive',
  props: {
    direction: {},
    consecutiveMonths: {},
    ratioThreshold: {},
    defaultValueString: { default: undefined }
  },
  emits: ['update:consecutiveMonths', 'update:ratioThreshold'],
  setup(__props: any, { emit: __emit }) {

const t = i18n.t;

const props = __props;
const emits = __emit;

const title = computed(() => (props.direction === 'excess' ? 'excess_forecast_consecutive_low' : 'shortage_forecast_consecutive_high'));
const text = computed(() => (props.direction === 'excess' ? 'dashboard:未満' : 'dashboard:より高い'));

return (_ctx: any,_cache: any) => {
  const _component_I18nT = _resolveComponent("I18nT")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, _toDisplayString(_unref(t)(title.value)), 1),
    _createElementVNode("div", null, [
      _createVNode(_component_I18nT, {
        keypath: "dashboard:ヶ月連続で",
        tag: "span"
      }, {
        input: _withCtx(() => [
          _createElementVNode("input", {
            value: _ctx.consecutiveMonths,
            type: "number",
            min: "1",
            max: "99",
            class: "alert-input-consecutive__input alert-input-consecutive__input--percentage",
            onInput: _cache[0] || (_cache[0] = ($event: any) => (emits('update:consecutiveMonths', $event))),
            onKeydown: _cache[1] || (_cache[1] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["e"]))
          }, null, 40, _hoisted_3)
        ]),
        _: 1
      }),
      _createVNode(_component_I18nT, {
        keypath: text.value,
        tag: "span"
      }, {
        input: _withCtx(() => [
          _createElementVNode("input", {
            value: _ctx.ratioThreshold,
            type: "number",
            min: "0",
            max: "999",
            class: "alert-input-consecutive__input alert-input-consecutive__input--percentage",
            onInput: _cache[2] || (_cache[2] = ($event: any) => (emits('update:ratioThreshold', $event))),
            onKeydown: _cache[3] || (_cache[3] = _withKeys(_withModifiers(() => {}, ["prevent"]), ["e"]))
          }, null, 40, _hoisted_4),
          _cache[4] || (_cache[4] = _createTextVNode(" % "))
        ]),
        _: 1
      }, 8, ["keypath"])
    ]),
    (_ctx.defaultValueString)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.defaultValueString), 1))
      : _createCommentVNode("", true)
  ]))
}
}

})